<template>
    <BaseForm v-if="project && errors">
        <template #fields>
            <TextAreaField
                :value="values.disturbanceNoise"
                :label="$t('project-disturbance-noise')"
                :error-messages="errors.disturbanceNoise"
                :max-length="ProjectDisturbanceSchema.shape.disturbanceNoise.maxLength ?? undefined"
                @input="setFieldValue('disturbanceNoise', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('disturbanceNoise', true)"
            />
            <TextAreaField
                :value="values.disturbanceDust"
                :label="$t('project-disturbance-dust')"
                :error-messages="errors.disturbanceDust"
                :max-length="ProjectDisturbanceSchema.shape.disturbanceDust.maxLength ?? undefined"
                @input="setFieldValue('disturbanceDust', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('disturbanceDust', true)"
            />
            <TextAreaField
                :value="values.disturbanceOther"
                :label="$t('project-disturbance-other')"
                :error-messages="errors.disturbanceOther"
                :max-length="ProjectDisturbanceSchema.shape.disturbanceOther.maxLength ?? undefined"
                @input="setFieldValue('disturbanceOther', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('disturbanceOther', true)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import TextAreaField from '@/components/Form/TextAreaField.vue';

import { useForm } from '@/forms/composables/useForm';
import { useProjectInjection } from '@/project/composables/useProjectInjection';
import { ProjectDisturbanceSchema } from '@/project/schemas';
import { computed } from 'vue';

const props = defineProps<{ projectId: string }>();

const projectId = computed(() => props.projectId);

const { project, updateProject } = useProjectInjection();

const { values, errors, setFieldValue, setFieldTouched, validate, onDiscard, resetForm } = useForm(
    ProjectDisturbanceSchema,
    computed(() => ({
        disturbanceNoise: project.value?.disturbanceNoise ?? '',
        disturbanceDust: project.value?.disturbanceDust ?? '',
        disturbanceOther: project.value?.disturbanceOther ?? '',
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await updateProject({ id: projectId.value, ...values.value });
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
